export const contactBriefingTranslations = {
  de: {
    contactResponsibilities: {
      title: 'Kontaktzuständigkeiten',
      description:
        'Zuständigkeiten für Ansprechpartner pflegen. Sie sind von Stellenbezeichnungen und Systemberechtigungen unabhängig. Verwendete Einträge können deaktiviert werden.',
      add: 'Zuständigkeit anlegen',
      name: 'Bezeichnung',
      order: 'Reihenfolge',
      translations: 'Mehrsprachige Bezeichnungen',
      active: 'Aktiv',
      inactive: 'Deaktiviert – bestehende Zuordnung bleibt erhalten',
      ambiguous: 'Übernommene Bezeichnung bitte prüfen',
      usage: 'Bei {{count}} Kontakten verwendet',
      saved: 'Zuständigkeit gespeichert',
      saveError:
        'Speichern fehlgeschlagen. Bezeichnung und vorhandene Dubletten prüfen. Eingaben bleiben erhalten.',
      help: 'Hilfe zu Zuständigkeiten',
    },
    briefing: {
      overview: 'Kundenüberblick',
      lastContact: 'Letzter persönlicher Kontakt',
      noData: 'Keine dokumentierte Angabe',
      noHistory: 'Keine ausreichende Bestellhistorie verfügbar.',
      period: 'Ausgewertete Bestellungen: {{from}} bis {{to}}',
      clarifications: 'Vor dem Gespräch klären',
      topics: 'Gesprächsthemen',
      noTopics: 'Keine konkreten offenen Gesprächsthemen aus den vorhandenen Daten.',
      contacts: 'Ansprechpartner',
      manualContact: 'Keine eindeutige Zuständigkeit belegt. Ansprechpartner bewusst auswählen.',
      matchReason:
        'Vorschlag aufgrund der aktiven, zugeordneten Zuständigkeit. Mehrere passende Kontakte bleiben auswählbar.',
      openDocument: 'Beleg öffnen',
      openFile: 'Kundenakte öffnen',
      openCase: 'Reklamation öffnen',
      openTask: 'Aufgabe öffnen',
      source: 'Zugrunde liegender Vorgang',
      sources: 'Alle Fakten und Quellen',
      refresh: 'Aktualisieren',
      generated: 'Stand: {{date}} · Quellen: berechtigte ERP-Daten',
      error:
        'Vorbereitung konnte nicht aktualisiert werden. Angezeigte ältere Daten bitte vor dem Gespräch aktualisieren.',
      noPhone: 'Keine Telefonnummer hinterlegt',
      phoneRestricted:
        'Telefonischer Vertriebskontakt ist eingeschränkt. Kontaktpräferenzen beachten.',
      preferredTime: 'Bevorzugte Kontaktzeit: {{from}}–{{to}}',
      call: 'Jetzt anrufen',
      aiSuggestion: 'Optionaler KI-Formulierungsvorschlag',
      aiRequest: 'Optionale Formulierungshilfe',
      aiLoading: 'Formulierungsvorschläge werden geladen …',
      aiUnavailable:
        'Formulierungshilfe nicht verfügbar. Fakten und Gesprächsthemen bleiben nutzbar.',
      note: 'Gesprächsnotiz / Vorbereitung',
      notContact:
        'Notizen bleiben beim Aktualisieren erhalten. Vorbereitung und Notizen zählen nicht als erfolgtes Gespräch.',
      saveNote: 'Notiz speichern',
      noteSaved: 'Notiz gespeichert',
      noteError: 'Notiz konnte nicht gespeichert werden. Ihre Eingabe bleibt erhalten.',
      callback: 'Rückruf planen',
      task: 'Aufgabe anlegen',
      CONTACT_BLOCK: 'Allgemeine Kontaktsperre aktiv.',
      MARKETING_BLOCK: 'Werbliche Kontaktaufnahme gesperrt.',
      relevance: {
        OPEN_COMPLAINT:
          'Der Vorgang ist noch offen und sollte vor weiteren Verkaufsfragen geklärt werden.',
        OVERDUE_INVOICE:
          'Überfällige Rechnungen erfordern eine sachliche Klärung des Zahlungsstands.',
        OPEN_TASK:
          'Eine offene Aufgabe benötigt einen nächsten Schritt; das Fälligkeitsdatum steht beim Anlass.',
        OPEN_QUOTE:
          'Das versendete Angebot hat noch keinen Folgebeleg. Ein Entscheidungsstand ist nicht dokumentiert.',
        REORDER_OVERDUE:
          'Der dokumentierte Bestellrhythmus wurde überschritten; eine Kaufabsicht ist daraus nicht ableitbar.',
        MISSING_REGULAR_PRODUCT:
          'Ein bislang regelmäßig bestellter Artikel fehlt in den ausgewerteten Bestellungen.',
        MISSING_PRODUCT_CATEGORY:
          'Eine zuvor bestellte Warengruppe fehlt in den ausgewerteten Bestellungen.',
      },
      question: {
        OPEN_COMPLAINT: '„Was ist noch offen, und welcher nächste Schritt hilft bei der Klärung?“',
        OVERDUE_INVOICE: '„Fehlen Unterlagen oder gibt es Rückfragen zu den offenen Rechnungen?“',
        OPEN_TASK: '„Wie ist der aktuelle Stand, und was vereinbaren wir als nächsten Schritt?“',
        OPEN_QUOTE: '„Fehlen Ihnen noch Informationen, um über das Angebot zu entscheiden?“',
        REORDER_OVERDUE:
          '„Hat sich Ihr Bedarf oder Ihr Bestellablauf seit der letzten Bestellung verändert?“',
        MISSING_REGULAR_PRODUCT: '„Hat sich Ihr Bedarf für diesen Artikel verändert?“',
        MISSING_PRODUCT_CATEGORY: '„Gibt es Veränderungen beim Bedarf in dieser Warengruppe?“',
      },
    },
  },
  en: {
    contactResponsibilities: {
      title: 'Contact responsibilities',
      description:
        'Manage contact responsibilities, independently of job titles and system permissions. Used entries can be deactivated.',
      add: 'Add responsibility',
      name: 'Name',
      order: 'Sort order',
      translations: 'Translated labels',
      active: 'Active',
      inactive: 'Inactive – existing assignment retained',
      ambiguous: 'Please review the migrated label',
      usage: 'Used by {{count}} contacts',
      saved: 'Responsibility saved',
      saveError: 'Could not save. Check the name and duplicates. Your input is retained.',
      help: 'Responsibility help',
    },
    briefing: {
      overview: 'Customer overview',
      lastContact: 'Last personal contact',
      noData: 'No recorded information',
      noHistory: 'Insufficient order history available.',
      period: 'Orders evaluated: {{from}} to {{to}}',
      clarifications: 'Clarify before the conversation',
      topics: 'Conversation topics',
      noTopics: 'The available data does not indicate a specific open topic.',
      contacts: 'Contacts',
      manualContact: 'No clear responsibility recorded. Select a contact explicitly.',
      matchReason:
        'Suggested from the assigned active responsibility. All matching contacts remain selectable.',
      openDocument: 'Open document',
      openFile: 'Open customer file',
      openCase: 'Open complaint',
      openTask: 'Open task',
      source: 'Source record',
      sources: 'All facts and sources',
      refresh: 'Refresh',
      generated: 'As of {{date}} · Sources: authorized ERP data',
      error: 'Could not refresh the preparation. Refresh any older data before the conversation.',
      noPhone: 'No phone number recorded',
      phoneRestricted: 'Sales calls are restricted. Observe the contact preferences.',
      preferredTime: 'Preferred contact time: {{from}}–{{to}}',
      call: 'Call now',
      aiSuggestion: 'Optional AI wording suggestion',
      aiRequest: 'Optional wording assistance',
      aiLoading: 'Loading wording suggestions …',
      aiUnavailable: 'Wording assistance unavailable. Facts and topics remain usable.',
      note: 'Conversation note / preparation',
      notContact:
        'Notes survive refresh. Preparation and notes do not count as a completed conversation.',
      saveNote: 'Save note',
      noteSaved: 'Note saved',
      noteError: 'Could not save the note. Your input is retained.',
      callback: 'Plan callback',
      task: 'Create task',
      CONTACT_BLOCK: 'General contact block is active.',
      MARKETING_BLOCK: 'Marketing contact is blocked.',
      relevance: {
        OPEN_COMPLAINT:
          'The case is still open and should be clarified before further sales questions.',
        OVERDUE_INVOICE: 'Overdue invoices require clarification of the payment status.',
        OPEN_TASK: 'An open task needs a next step; its due date is shown with the trigger.',
        OPEN_QUOTE: 'The sent quote has no follow-up document. A decision has not been recorded.',
        REORDER_OVERDUE:
          'The recorded order interval has been exceeded; this does not imply purchase intent.',
        MISSING_REGULAR_PRODUCT: 'A previously regular item is absent from the evaluated orders.',
        MISSING_PRODUCT_CATEGORY:
          'A previously ordered category is absent from the evaluated orders.',
      },
      question: {
        OPEN_COMPLAINT: '“What remains unresolved, and which next step would help?”',
        OVERDUE_INVOICE:
          '“Are any documents missing, or are there questions about the outstanding invoices?”',
        OPEN_TASK: '“What is the current status, and what should we agree as the next step?”',
        OPEN_QUOTE: '“Do you need any further information to decide on the quote?”',
        REORDER_OVERDUE: '“Has your demand or ordering process changed since the last order?”',
        MISSING_REGULAR_PRODUCT: '“Has your need for this item changed?”',
        MISSING_PRODUCT_CATEGORY: '“Have your needs in this product category changed?”',
      },
    },
  },
  fr: {
    contactResponsibilities: {
      title: 'Responsabilités des contacts',
      description:
        'Gérez les responsabilités des contacts, indépendamment des postes et des droits système. Les entrées utilisées peuvent être désactivées.',
      add: 'Ajouter une responsabilité',
      name: 'Dénomination',
      order: 'Ordre',
      translations: 'Libellés multilingues',
      active: 'Actif',
      inactive: 'Désactivé – affectation existante conservée',
      ambiguous: 'Veuillez vérifier le libellé repris',
      usage: 'Utilisé par {{count}} contacts',
      saved: 'Responsabilité enregistrée',
      saveError:
        'Échec de l’enregistrement. Vérifiez le nom et les doublons. Votre saisie est conservée.',
      help: 'Aide sur les responsabilités',
    },
    briefing: {
      overview: 'Vue d’ensemble du client',
      lastContact: 'Dernier contact personnel',
      noData: 'Aucune information documentée',
      noHistory: 'Historique de commandes insuffisant.',
      period: 'Commandes analysées : du {{from}} au {{to}}',
      clarifications: 'À clarifier avant l’entretien',
      topics: 'Sujets de discussion',
      noTopics: 'Les données disponibles n’indiquent aucun sujet ouvert précis.',
      contacts: 'Interlocuteurs',
      manualContact: 'Aucune responsabilité claire documentée. Choisissez un interlocuteur.',
      matchReason:
        'Suggestion fondée sur la responsabilité active attribuée. Tous les contacts correspondants restent sélectionnables.',
      openDocument: 'Ouvrir le document',
      openFile: 'Ouvrir la fiche client',
      openCase: 'Ouvrir la réclamation',
      openTask: 'Ouvrir la tâche',
      source: 'Enregistrement source',
      sources: 'Tous les faits et sources',
      refresh: 'Actualiser',
      generated: 'État au {{date}} · Sources : données ERP autorisées',
      error:
        'Impossible d’actualiser la préparation. Actualisez les anciennes données avant l’entretien.',
      noPhone: 'Aucun numéro de téléphone',
      phoneRestricted:
        'Les appels commerciaux sont restreints. Respectez les préférences de contact.',
      preferredTime: 'Créneau préféré : {{from}}–{{to}}',
      call: 'Appeler maintenant',
      aiSuggestion: 'Suggestion de formulation IA facultative',
      aiRequest: 'Aide à la formulation facultative',
      aiLoading: 'Chargement des formulations…',
      aiUnavailable: 'Aide à la formulation indisponible. Les faits et sujets restent utilisables.',
      note: 'Note d’entretien / préparation',
      notContact:
        'Les notes sont conservées lors de l’actualisation. La préparation et les notes ne comptent pas comme un entretien réalisé.',
      saveNote: 'Enregistrer la note',
      noteSaved: 'Note enregistrée',
      noteError: 'Impossible d’enregistrer la note. Votre saisie est conservée.',
      callback: 'Planifier un rappel',
      task: 'Créer une tâche',
      CONTACT_BLOCK: 'Blocage général des contacts actif.',
      MARKETING_BLOCK: 'Contact commercial bloqué.',
      relevance: {
        OPEN_COMPLAINT:
          'Le dossier reste ouvert et doit être clarifié avant de nouvelles questions commerciales.',
        OVERDUE_INVOICE: 'Les factures échues nécessitent une clarification des paiements.',
        OPEN_TASK: 'Une tâche ouverte nécessite une prochaine étape ; son échéance est indiquée.',
        OPEN_QUOTE:
          'Le devis envoyé n’a pas de document consécutif. Aucune décision n’est documentée.',
        REORDER_OVERDUE:
          'Le rythme de commande enregistré est dépassé ; cela ne prouve aucune intention d’achat.',
        MISSING_REGULAR_PRODUCT:
          'Un article auparavant régulier manque dans les commandes analysées.',
        MISSING_PRODUCT_CATEGORY:
          'Une catégorie auparavant commandée manque dans les commandes analysées.',
      },
      question: {
        OPEN_COMPLAINT: '« Que reste-t-il à résoudre et quelle prochaine étape serait utile ? »',
        OVERDUE_INVOICE:
          '« Manque-t-il des documents ou avez-vous des questions sur les factures impayées ? »',
        OPEN_TASK: '« Quel est l’état actuel et quelle prochaine étape convenons-nous ? »',
        OPEN_QUOTE: '« Vous manque-t-il des informations pour vous prononcer sur le devis ? »',
        REORDER_OVERDUE:
          '« Vos besoins ou votre processus de commande ont-ils changé depuis la dernière commande ? »',
        MISSING_REGULAR_PRODUCT: '« Votre besoin pour cet article a-t-il changé ? »',
        MISSING_PRODUCT_CATEGORY: '« Vos besoins dans cette catégorie ont-ils évolué ? »',
      },
    },
  },
  es: {
    contactResponsibilities: {
      title: 'Responsabilidades de los contactos',
      description:
        'Gestione las responsabilidades, separadas de los cargos y permisos del sistema. Las entradas utilizadas se pueden desactivar.',
      add: 'Añadir responsabilidad',
      name: 'Nombre',
      order: 'Orden',
      translations: 'Nombres traducidos',
      active: 'Activo',
      inactive: 'Inactivo – se conserva la asignación',
      ambiguous: 'Revise el nombre migrado',
      usage: 'Usado en {{count}} contactos',
      saved: 'Responsabilidad guardada',
      saveError: 'No se pudo guardar. Revise el nombre y los duplicados. Se conserva la entrada.',
      help: 'Ayuda sobre responsabilidades',
    },
    briefing: {
      overview: 'Resumen del cliente',
      lastContact: 'Último contacto personal',
      noData: 'Sin información registrada',
      noHistory: 'Historial de pedidos insuficiente.',
      period: 'Pedidos evaluados: de {{from}} a {{to}}',
      clarifications: 'Aclarar antes de la conversación',
      topics: 'Temas de conversación',
      noTopics: 'Los datos disponibles no indican temas abiertos concretos.',
      contacts: 'Contactos',
      manualContact: 'No hay una responsabilidad clara registrada. Seleccione un contacto.',
      matchReason:
        'Sugerido por la responsabilidad activa asignada. Todos los contactos coincidentes siguen disponibles.',
      openDocument: 'Abrir documento',
      openFile: 'Abrir ficha del cliente',
      openCase: 'Abrir reclamación',
      openTask: 'Abrir tarea',
      source: 'Registro de origen',
      sources: 'Todos los datos y fuentes',
      refresh: 'Actualizar',
      generated: 'Estado: {{date}} · Fuentes: datos ERP autorizados',
      error:
        'No se pudo actualizar la preparación. Actualice los datos anteriores antes de conversar.',
      noPhone: 'Sin teléfono registrado',
      phoneRestricted:
        'Las llamadas comerciales están restringidas. Respete las preferencias de contacto.',
      preferredTime: 'Horario preferido: {{from}}–{{to}}',
      call: 'Llamar ahora',
      aiSuggestion: 'Sugerencia opcional de redacción con IA',
      aiRequest: 'Ayuda opcional de redacción',
      aiLoading: 'Cargando sugerencias de redacción…',
      aiUnavailable: 'Ayuda de redacción no disponible. Los datos y temas siguen disponibles.',
      note: 'Nota de conversación / preparación',
      notContact:
        'Las notas se conservan al actualizar. La preparación y las notas no cuentan como conversación realizada.',
      saveNote: 'Guardar nota',
      noteSaved: 'Nota guardada',
      noteError: 'No se pudo guardar la nota. Se conserva su entrada.',
      callback: 'Planificar devolución de llamada',
      task: 'Crear tarea',
      CONTACT_BLOCK: 'Bloqueo general de contacto activo.',
      MARKETING_BLOCK: 'Contacto publicitario bloqueado.',
      relevance: {
        OPEN_COMPLAINT:
          'El caso sigue abierto y debe aclararse antes de otras cuestiones comerciales.',
        OVERDUE_INVOICE: 'Las facturas vencidas requieren aclarar el estado del pago.',
        OPEN_TASK: 'Una tarea abierta necesita un siguiente paso; se muestra su vencimiento.',
        OPEN_QUOTE: 'La oferta enviada no tiene documento posterior. No consta una decisión.',
        REORDER_OVERDUE:
          'Se ha superado el intervalo de pedidos registrado; esto no implica intención de compra.',
        MISSING_REGULAR_PRODUCT: 'Un artículo antes habitual falta en los pedidos evaluados.',
        MISSING_PRODUCT_CATEGORY: 'Una categoría antes pedida falta en los pedidos evaluados.',
      },
      question: {
        OPEN_COMPLAINT: '«¿Qué queda pendiente y qué siguiente paso ayudaría?»',
        OVERDUE_INVOICE: '«¿Faltan documentos o hay dudas sobre las facturas pendientes?»',
        OPEN_TASK: '«¿Cuál es el estado actual y qué acordamos como siguiente paso?»',
        OPEN_QUOTE: '«¿Necesita más información para decidir sobre la oferta?»',
        REORDER_OVERDUE: '«¿Han cambiado sus necesidades o su proceso desde el último pedido?»',
        MISSING_REGULAR_PRODUCT: '«¿Ha cambiado su necesidad de este artículo?»',
        MISSING_PRODUCT_CATEGORY: '«¿Han cambiado sus necesidades en esta categoría?»',
      },
    },
  },
  tr: {
    contactResponsibilities: {
      title: 'Kişi sorumlulukları',
      description:
        'Kişi sorumluluklarını unvanlardan ve sistem yetkilerinden bağımsız yönetin. Kullanılan kayıtlar devre dışı bırakılabilir.',
      add: 'Sorumluluk ekle',
      name: 'Ad',
      order: 'Sıralama',
      translations: 'Çok dilli adlar',
      active: 'Etkin',
      inactive: 'Devre dışı – mevcut atama korunur',
      ambiguous: 'Aktarılan adı kontrol edin',
      usage: '{{count}} kişide kullanılıyor',
      saved: 'Sorumluluk kaydedildi',
      saveError: 'Kaydedilemedi. Adı ve yinelenen kayıtları kontrol edin. Girdiler korunur.',
      help: 'Sorumluluk yardımı',
    },
    briefing: {
      overview: 'Müşteri özeti',
      lastContact: 'Son kişisel görüşme',
      noData: 'Kayıtlı bilgi yok',
      noHistory: 'Yeterli sipariş geçmişi yok.',
      period: 'İncelenen siparişler: {{from}} – {{to}}',
      clarifications: 'Görüşmeden önce netleştirin',
      topics: 'Görüşme konuları',
      noTopics: 'Mevcut veriler belirli bir açık konu göstermiyor.',
      contacts: 'İlgili kişiler',
      manualContact: 'Kesin sorumluluk kaydı yok. İlgili kişiyi seçin.',
      matchReason: 'Atanan etkin sorumluluğa göre önerilir. Eşleşen tüm kişiler seçilebilir.',
      openDocument: 'Belgeyi aç',
      openFile: 'Müşteri kaydını aç',
      openCase: 'Şikâyeti aç',
      openTask: 'Görevi aç',
      source: 'Kaynak kayıt',
      sources: 'Tüm bilgiler ve kaynaklar',
      refresh: 'Yenile',
      generated: 'Durum: {{date}} · Kaynaklar: yetkili ERP verileri',
      error: 'Hazırlık yenilenemedi. Görüşmeden önce eski verileri yenileyin.',
      noPhone: 'Telefon numarası kayıtlı değil',
      phoneRestricted: 'Satış aramaları kısıtlı. İletişim tercihlerini dikkate alın.',
      preferredTime: 'Tercih edilen saat: {{from}}–{{to}}',
      call: 'Şimdi ara',
      aiSuggestion: 'İsteğe bağlı YZ ifade önerisi',
      aiRequest: 'İsteğe bağlı ifade desteği',
      aiLoading: 'İfade önerileri yükleniyor…',
      aiUnavailable: 'İfade desteği kullanılamıyor. Bilgiler ve konular kullanılabilir.',
      note: 'Görüşme notu / hazırlık',
      notContact: 'Yenileme notları korur. Hazırlık ve notlar gerçekleşmiş görüşme sayılmaz.',
      saveNote: 'Notu kaydet',
      noteSaved: 'Not kaydedildi',
      noteError: 'Not kaydedilemedi. Girdiniz korunur.',
      callback: 'Geri arama planla',
      task: 'Görev oluştur',
      CONTACT_BLOCK: 'Genel iletişim engeli etkin.',
      MARKETING_BLOCK: 'Pazarlama iletişimi engelli.',
      relevance: {
        OPEN_COMPLAINT: 'Kayıt açık; diğer satış sorularından önce netleştirilmelidir.',
        OVERDUE_INVOICE: 'Vadesi geçen faturaların ödeme durumu netleştirilmelidir.',
        OPEN_TASK: 'Açık görev için sonraki adım gerekir; son tarih konuda gösterilir.',
        OPEN_QUOTE: 'Gönderilen teklifin takip belgesi yok. Karar kaydı bulunmuyor.',
        REORDER_OVERDUE: 'Kayıtlı sipariş aralığı aşıldı; bu satın alma niyeti göstermez.',
        MISSING_REGULAR_PRODUCT: 'Daha önce düzenli alınan ürün incelenen siparişlerde yok.',
        MISSING_PRODUCT_CATEGORY: 'Daha önce sipariş edilen ürün grubu incelenen siparişlerde yok.',
      },
      question: {
        OPEN_COMPLAINT: '“Hangi noktalar açık ve hangi sonraki adım çözüm sağlar?”',
        OVERDUE_INVOICE: '“Açık faturalarla ilgili eksik belge veya soru var mı?”',
        OPEN_TASK: '“Güncel durum nedir ve sonraki adım olarak ne kararlaştıralım?”',
        OPEN_QUOTE: '“Teklif hakkında karar vermek için başka bilgi gerekiyor mu?”',
        REORDER_OVERDUE: '“Son siparişten beri ihtiyacınız veya sipariş süreciniz değişti mi?”',
        MISSING_REGULAR_PRODUCT: '“Bu ürüne olan ihtiyacınız değişti mi?”',
        MISSING_PRODUCT_CATEGORY: '“Bu ürün grubundaki ihtiyacınız değişti mi?”',
      },
    },
  },
};
